import axios from 'axios'
const service = axios.create({// 创建axios实例
    // baseURL: IPCONFIG, // 配置baseurl,url = base url + request url    process.env.VUE_APP_BASE_API------IPCONFIG
    timeout: 10000,

})
service.interceptors.request.use( // 拦截request
    config => {
        if(sessionStorage.token){
            config.headers['Authorization'] = sessionStorage.token
        }
        return config
    },
    error => {
      console.log(error) // for debug
      return Promise.reject(error)
    }
)
service.interceptors.response.use(// 拦截response
    response => {
      const res = response.data
      console.log('-----------------------拦截', response)
      // 上传图片
      if(res.errno == 0){
        return res;
      }
      if (res.code != 200) {
        // 401:非法的token; 50014:Token 过期了;
        if(res.code == 401){
          return Promise.reject('请重新登录')
        }
        return Promise.reject(res.msg || 'error')
      } else {
        return res
      }
    },
    error => {
      sessionStorage.clear();
      return Promise.reject('请重新登录')
    }
)
export default service



// WEBPACK FOOTER //
// ./src/utils/request.js